import React from "react";
import '../../styles/components/settings/settings-section.scss';
import {appPagePaths} from "../../config/config";
import logoPGSVertical from "./images/logo-playground-sessions-vertical.svg";
import ExternalLink from "../common/ExternalLink";
import {FontIcon} from "../common/FontIcon";
import Button from "../common/Button";
import {navigate} from "../../services/navigation/navigation";
import deviceInfo from "../../services/deviceInfo/deviceInfo";
import nativeBridge from "../../services/nativeBridge";
import {appEnvVersion,} from "../../config/environment";
import {useAppSelector} from "../../redux/hooks";
import {WhenEnvIsDev} from "../conditional/env-is/WhenEnvIsDev";
import {WhenEnvIsDevLocal} from "../conditional/env-is/WhenEnvIsDevLocal";
import {DebugDeviceMockAndLogging} from "../../modules/debug/device-mock/DebugDeviceMockAndLogging";
import {localStorageService} from "../../services/storage/local-storage";
import {sessionStorageService} from "../../services/storage/session-storage";
import {computerUuidRepository} from "../../repositories/device-info/computer-uuid-repository";
import {isDefined} from "../../util/is-type";
import {deviceStore} from "../../redux/device/deviceStore";
import {baseUrlForWebsite} from "../../client/PlaygroundSettings";

const appSelfRepairHandler = () => {
  // get computer uuid (to try and prevent adding to install count)
  const computerUuid = computerUuidRepository.get();
  // clear session storage
  sessionStorageService.clear();
  // clear local storage
  localStorageService.clear();
  // did we get a computer uuid as expected?
  if (isDefined(computerUuid)) {
    // write computer install id back to prior to prevent install count
    computerUuidRepository.set(computerUuid);
  }
  // take user back to fresh entry of app
  navigate(`/`);
}

export default function AboutSection() {
  const isMobile = useAppSelector(deviceStore.getDeviceIsMobile);
  const deviceBrowserName = useAppSelector(deviceStore.getDeviceBrowserName);
  const deviceOsVersion = useAppSelector(deviceStore.getDeviceOsVersion);

  const rateTheAppButton = deviceInfo.getIsMobile()
    ? null
    : <Button text={"Rate the App"} buttonType={"secondary"} onClick={()=> nativeBridge.tellNativeToPromptTheUserToRateTheApp()} />;
  return (
    <div className="settings-section about">
      <header>About Playground Sessions</header>
      <main className="settings">
        <img className="logo" src={logoPGSVertical} alt="Playground Sessions"/>
        <div className="app-version">{appEnvVersion} — phone: {isMobile + ''}</div>
        <div className={`device-version`}>
          <div>{deviceBrowserName} &nbsp;</div>
          <div>{deviceOsVersion} &nbsp; </div>
        </div>
        <ExternalLink url={`${baseUrlForWebsite}`} title="playgroundsessions.com"/>
        <ExternalLink url="mailto:support@playgroundsessions.com" title={"Playground Support"}/>
        <div className="social-media-links">
          <ExternalLink url="https://www.facebook.com/theplaygroundsessions" title={<FontIcon icon={"icon-facebook-f"}/>}/>
          <ExternalLink url="https://www.instagram.com/playgroundsessions/" title={<FontIcon icon={"icon-instagram"}/>}/>
          <ExternalLink url="https://twitter.com/playgroundpiano" title={<FontIcon icon={"icon-twitter"}/>}/>
          <ExternalLink url="https://www.youtube.com/user/PlaygroundPiano" title={<FontIcon icon={"icon-youtube"}/>}/>
        </div>
        <div className={"app-rating"}>
          {rateTheAppButton}
          <WhenEnvIsDev>
            <Button text={"Intro"} onClick={()=> navigate(appPagePaths.infoPage)}/>
            <Button text={"Repair App"} onClick={appSelfRepairHandler}/>
          </WhenEnvIsDev>
        </div>
        <WhenEnvIsDevLocal>
          <DebugDeviceMockAndLogging />
        </WhenEnvIsDevLocal>
      </main>
    </div>
  );
}